/**
 * Service layer per il tracciamento newsletter (RF-06 / §11.8).
 *  - metrics aggregati: dentro GET /newsletters/{id} (campo `metrics`).
 *  - per-destinatario: GET /newsletters/{id}/recipients (paginato; filtri status, opened, q).
 *  - per-link: GET /newsletters/{id}/link-stats (array ordinato per click desc).
 *
 * Auth: NEWSLETTER R sull'entità (enforcement lato BE).
 */
import API from '../../api';

export const trackingApi = {
  /** GET /newsletters/{id} — gli aggregati sono in `.data.metrics`. */
  getMetrics: (id) => API.get(`/newsletters/${id}`),

  /**
   * GET /newsletters/{id}/recipients — dettaglio per-destinatario (paginato).
   * params: { page, status, opened: true|false, q }
   */
  getRecipients: (id, params) => API.get(`/newsletters/${id}/recipients`, { params }),

  /** GET /newsletters/{id}/link-stats — [{ id, original_url, total_clicks, unique_clicks }]. */
  getLinkStats: (id) => API.get(`/newsletters/${id}/link-stats`),
};

export default trackingApi;
